export type BannedShiftToggleResult = {
  readonly kind: "updated";
  readonly shiftIds: readonly string[];
};

export function toggleBannedShiftIds(
  currentShiftIds: readonly string[],
  selectedShiftId: string
): BannedShiftToggleResult {
  if (currentShiftIds.includes(selectedShiftId)) {
    return {
      kind: "updated",
      shiftIds: currentShiftIds.filter((shiftId) => shiftId !== selectedShiftId),
    };
  }

  return {
    kind: "updated",
    shiftIds: [...currentShiftIds, selectedShiftId],
  };
}
